
export default {
    realname: '',
    type: null,
    timeout: +localStorage.getItem('psxly_timeout') || .50 * 60 * 1000,
    timeoutShow: +localStorage.getItem('psxly_timeout') <= 0,



} 